import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['advanceFilterButton', 'advanceFilterContainer', 'searchInput']

  initialize(){
    this.updateTextFieldStyleIfArabic();
  }

  connect(){
    this.element.addEventListener("input", this.handleInput.bind(this));
    
    // Bind and listen for clicks anywhere on the document.
    // If a click happens outside the filter container and filter toggle button,
    // and it's not inside a Select2 dropdown, the filter will be closed.
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this.handleOutsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick(event) {
    const container = this.advanceFilterContainerTarget;
    const button    = this.advanceFilterButtonTarget;

    const clickedInsideContainer = container.contains(event.target);
    const clickedButton = button.contains(event.target);

    const isSelect2Dropdown = event.target.closest('.select2-container');

    if (!clickedInsideContainer && !clickedButton && !isSelect2Dropdown && !container.classList.contains("collapse")) {
      container.classList.add("collapse")
    }
  }

  handleInput(event) {
    const searchTextField = event.target;
    const searchValue     = searchTextField.value;

    if (searchValue.match(/[\u0600-\u06FF]/)) { // Arabic characters
      searchTextField.classList.add("arabic-text-global-search");
      searchTextField.classList.remove("english-text-global-search");
    } else {
      searchTextField.classList.add("english-text-global-search");
      searchTextField.classList.remove("arabic-text-global-search");
    }
  }

  updateTextFieldStyleIfArabic() {
    const searchTextField = this.searchInputTarget;
    const arabicRegex = /[\u0600-\u06FF]/;

    if (arabicRegex.test(searchTextField.value)) {
      searchTextField.classList.add("arabic-text-global-search");
    }
  }

  toggleAdvanceFilters(){
    this.advanceFilterContainerTarget.classList.toggle('collapse')
  }
}
